app.service("SolutionService", ['$rootScope', function ($rootScope) {

    const service = this;
    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const RouteChoice = modelConstructor.RouteChoice;

    const SolutionModel = modelConstructor.extend(modelConstructor.RouteModel, {
        id: "solution",
        navigation_pointer: "solution_id",
        name: "Solution",
        next_model_id: "method_input",
        choice_order: ['kitchen_rigid_flat_pack', 'kitchen_inrail', 'bedroom_flat_pack']
    });

    this.factory = new modelConstructor.RouteFactory({
        choices: {
            kitchen_rigid_flat_pack: new RouteChoice({
                name: "Rigid/Flat-Pack Kitchens",
                //name: "Flat-Pack Kitchens",
                img_src: "/img/browse/property/solution/solution-rigid-kitchen.png",
                //img_src: "/img/browse/property/solution/solution-flat-pack-kitchen.png",
                state_ids: {
                    room_id: "kitchen"
                }
            }),
            kitchen_inrail: new RouteChoice({
                name: "InRail Rigid Kitchens",
                img_src: "/img/browse/property/solution/solution-inrail-rigid-kitchen.png",
                state_ids: {
                    room_id: "kitchen",
                    assembly_id: "rigid"
                }
            }),
            bedroom_flat_pack: new RouteChoice({
                name: "Flat-Pack Bedrooms",
                img_src: "/img/browse/property/solution/solution-flat-pack-bedroom.png",
                state_ids: {
                    room_id: "bedroom",
                    assembly_id: "flat_pack"
                }
            })
        },
        birth: function (values) {
            return new SolutionModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;
        const roomID = variationIDs.room_id;

        const baseComponentID = variationIDs.base_component_id;
        const productID = variationIDs.product_id;

        const choiceOrder = model.choice_order;
        let nextModelID = model.next_model_id;

        if (roomID) {
            for (let choiceID in service.factory.choices) {
                const index = choiceOrder.indexOf(choiceID);
                if (index >= 0) {
                    const choice = service.factory.choices[choiceID];
                    if (choice.state_ids.room_id !== roomID) {
                        choiceOrder.splice(index, 1)
                    }
                }
            }
        }

        const productCache = $rootScope.service.cache_local_server.getComponentProduct(baseComponentID, productID);
        if (productCache && productCache.solution_ids) {
            for (let i = 0; i < choiceOrder.length; i++) {
                if (!productCache.solution_ids.includes(choiceOrder[i])) {
                    choiceOrder.splice(i, 1);
                    i--;
                }
            }
            nextModelID = "door_type";
        }

        const choices = siteHelper.cloneChoices(
            service.factory.choices
            , choiceOrder);

        for (let choiceID in choices) {
            const choice = choices[choiceID];
            choice.state_values.solutionName = choice.name;
        }

        siteHelper.applyValues(model, {
            choices: choices,
            choice_order: choiceOrder,
            next_model_id: nextModelID
        });
    }

}]);